define('constants/liveReceptionistScriptAgentToneConstants',[], function() {
    return {
        Professional: "0",
        Casual: "1"
    };
});
